import React from 'react';

export interface EmbeddedExerciseEditorContextType {
  /** When set, indicates the exercise editor is embedded (e.g. inside a modal). */
  isEmbedded: true;
  /** Close the embedding container (e.g. the modal). */
  onClose: () => void;
}

const EmbeddedExerciseEditorContext = React.createContext<EmbeddedExerciseEditorContextType | null>(
  null,
);

export const EmbeddedExerciseEditorProvider = EmbeddedExerciseEditorContext.Provider;

export const useEmbeddedExerciseEditor = () => React.useContext(EmbeddedExerciseEditorContext);
